// Custom Reports Redux Action Types - Following approval pattern

export const SETDATASETSLIST = "SETDATASETSLIST";
export const SETDATASETCOLUMNS = "SETDATASETCOLUMNS";
export const SETVIEWCOLUMNS = "SETVIEWCOLUMNS";
export const SETREPORTOUTPUT = "SETREPORTOUTPUT";
export const SETREPORTPREVIEW = "SETREPORTPREVIEW";
export const SETSAVEDREPORTSLIST = "SETSAVEDREPORTSLIST";
export const SETSELECTEDDATASET = "SETSELECTEDDATASET";
export const SETSELECTEDCOLUMNS = "SETSELECTEDCOLUMNS";
export const SETREPORTCONFIG = "SETREPORTCONFIG";
export const SETPUBLISHEDREPORT = "SETPUBLISHEDREPORT";
export const SETCOLUMNFORMATTING = "SETCOLUMNFORMATTING";
export const SETCOLUMNFORMATTINGSAVING = "SETCOLUMNFORMATTINGSAVING";
export const SETCUSTOMREPORTSLIST = "SETCUSTOMREPORTSLIST";
export const RESETCUSTOMREPORTSSTATE = "RESETCUSTOMREPORTSSTATE";
export const SETREPORTDETAILS = "SETREPORTDETAILS";
export const SETUPDATEDREPORT = "SETUPDATEDREPORT";
export const SETREPORTPARAMETERS = "SETREPORTPARAMETERS";
export const SETUSERSFORSHARE = "SETUSERSFORSHARE";
export const SETROLESFORSHARE = "SETROLESFORSHARE";
export const SETSHAREDREPORT = "SETSHAREDREPORT";
export const SETSHAREREPORTSAVING = "SETSHAREREPORTSAVING";
export const SETREPORTSHARES = "SETREPORTSHARES";
export const SETUPDATEDREPORTSHARE = "SETUPDATEDREPORTSHARE";
export const SETUPDATEREPORTSHARESAVING = "SETUPDATEREPORTSHARESAVING";
export const SETDELETEDREPORTSHARE = "SETDELETEDREPORTSHARE";
export const SETDELETEREPORTSHARESAVING = "SETDELETEREPORTSHARESAVING";